export default __webpack_public_path__ + "images/0x152b9d0fdc40c096757f570a51e494bd4b943e50.png";